import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { 
  HiHome, 
  HiOutlineCloudUpload,
} from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";
import Route from "./Route";
import DriveStats from "./DriveStats";
import CreateFolderModal from "./CreateFolderModal";

export default function NavBar() {
  const navigate = useNavigate();
  const { user, menuOpen } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navItems = [
    { name: "Home", icon: <HiHome />, path: "/my/home" },
  ];

  return (
    <>
      <div className={`h-screen flex flex-col sidebar-gradient text-slate-300 transition-all duration-500 ease-in-out ${menuOpen ? "w-72" : "w-20 items-center"}`}>
        {/* Logo & Brand */}
        <div className={`p-6 flex items-center gap-3 ${!menuOpen && "justify-center"}`}>
          <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shadow-lg neon-glow overflow-hidden">
            <img src={logo} alt="logo" className="w-8 h-8 object-contain" />
          </div>
          {menuOpen && (
            <span className="text-xl font-bold text-white tracking-tight">BVM<span className="text-indigo-400">Drive</span></span>
          )}
        </div>

        {/* New Button */}
        <div className="px-4 mb-8">
          <button 
            onClick={() => setIsModalOpen(true)}
            className={`flex items-center gap-3 bg-white hover:bg-slate-50 text-slate-900 shadow-xl transition-all duration-300 group rounded-2xl ${menuOpen ? "px-6 py-4 w-full" : "w-12 h-12 justify-center"}`}
          >
            <div className="w-6 h-6 rounded-lg bg-indigo-600 flex items-center justify-center text-white group-hover:rotate-90 transition-transform">
              <FaPlus size={12} />
            </div>
            {menuOpen && <span className="font-bold text-sm tracking-wide">New</span>}
          </button>
        </div>

        {/* Navigation Items */}
        <div className="flex-1 overflow-y-auto px-2 space-y-1 fancy-scrollbar">
          {navItems.map((item) => (
            <Route
              key={item.path}
              name={item.name}
              icon={item.icon}
              onClick={() => navigate(item.path)}
              urlPath={item.path}
              isCollapsed={!menuOpen}
            />
          ))}
        </div>

        {/* Storage Stats Section */}
        {menuOpen && (
          <div className="p-4 bg-slate-800/50 m-4 rounded-2xl border border-slate-700/50">
            <div className="flex items-center gap-2 mb-3 text-white">
              <HiOutlineCloudUpload className="text-indigo-400" />
              <span className="text-xs font-bold uppercase tracking-wider">Cloud Storage</span>
            </div>
            <DriveStats 
              usedMB={user?.storageInfo?.totalUsedMB || 0} 
              totalGB={user?.storageInfo?.totalAllowedGB || 0} 
              percentage={user?.storageInfo?.usagePercent || 0}
            />
          </div>
        )}
        {!menuOpen && (
          <div className="mb-8 cursor-pointer hover:text-indigo-400 transition-colors">
            <HiOutlineCloudUpload size={24} />
          </div>
        )}
      </div>

      <CreateFolderModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onSuccess={() => {
          // You could trigger a refresh here if needed
          console.log("Folder created, refreshing...");
        }}
      />
    </>
  );
}


